export const environment = {
  production: false,
  apiurl: 'https://devtisaapapi.vemoit.com',
};
